export class PersistedFolder {
  MountPath = '';

  persistentVolumeClaimName = '';

  HostPath = '';
}
